// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/stoessel-mit-feder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const stoesselMitFederDE: PageEntry = {
  id: "post.stoessel-mit-feder",
  locale: "de",
  slug: "stoessel-mit-feder",
  seo: {
    title: "Glossar: Stößel mit Feder einfach erklärt | Dietz GmbH",
    description: "Ein Stößel mit Feder ist ein Bauteil in mechanischen Systemen, das eine Feder in Kombination mit einem Stößel oder einer Kolbenstange verwendet. Diese Konstruktion ermöglicht es, F",
  },
  type: "post",
  h1: "Glossar: Stößel mit Feder einfach erklärt",
  intro: "Ein Stößel mit Feder ist ein Bauteil in mechanischen Systemen, das eine Feder in Kombination mit einem Stößel oder einer Kolbenstange verwendet. Diese Konstruktion ermöglicht es, Federkraft in lineare Bewegung umzuwandeln oder eine mechanische Dämpfung zu erreichen. Stößel mit Feder finden Anwendung in verschiedenen Maschinen und Geräten, insbesondere in solchen, die eine präzise Steuerung von Bewegungen erfordern. Die Auswahl der geeigneten Feder und die richtige Abstimmung des Stößel-Mechanismus sind entscheidend für die Effizienz und Leistung des Gesamtsystems.",
  blocks: [

  ],
};
